import React, { useState } from "react";
import axios from "axios";
import uploadImg from "../../images/upload-icon.svg";
import { END_URL } from '../../config';

const PopupMessage = ({ message, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <p>{message}</p>
        <button onClick={onClose} className="popup-ok-button">OK</button>
      </div>
    </div>
  );
};


  // export const fileTypeOptions = [
  //   { label: "Receipt / Proof of Purchase", value: "Receipt" },
  //   { label: "Credit Card Statement", value: "CreditCardStatement" },
  //   { label: "Bank Statement", value: "BankStatement" },
  //   { label: "Flybuys Statement", value: "FlybuysStatement" },
  //   { label: "Email Confirmation / Invoice", value: "EmailConfirmationInvoice" },
  //   { label: "In-store Purchase Summary", value: "InStorePurchaseSummary" },
  //   { label: "Correspondence with Supermarket", value: "CorrespondenceWithSupermarket" },
  //   { label: "Screenshot of Transaction", value: "ScreenshotOfTransaction" },
  //   { label: "Photo of Item / Shelf Price", value: "PhotoOfItemShelfPrice" },
  //   { label: "Other Document / Evidence", value: "OtherDocument" }
  // ];





const UploadFileWidget = () => {
  // State Variables
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [popupMessage, setPopupMessage] = useState(""); // For popup messages

  // Event Handlers
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile.size > 50 * 1024 * 1024) {
      setPopupMessage("File size exceeds the maximum limit of 50 MB.");
      return;
    }
    setFile(selectedFile);
    setProgress(0);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    if (event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];
      if (droppedFile.size > 50 * 1024 * 1024) {
        setPopupMessage("File size exceeds the maximum limit of 50 MB.");
        return;
      }
      setFile(droppedFile);
      setProgress(0);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setPopupMessage("Please select a file to upload.");
      return;
    }

    if (!fileType) {
      setPopupMessage("Please select a file type.");
      return;
    }



    const formData = new FormData();
    formData.append("image", file);
    formData.append("filetype", fileType);

    try {
      const token = sessionStorage.getItem("authToken");
      // await axios.post(
      //   "https://woolworths-classaction.staging3.dotwibe.com/api/api/evidence",

      await axios.post(
        `${END_URL}evidence`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgress(percentCompleted);
            }
          },
        }
      );
      setPopupMessage("Success");
        setTimeout(() => {
          setPopupMessage("");
          window.location.reload();
        
          setFile(null);
          setProgress(0);
          setFileType("");
        }, 2000); // 3 seconds

    } catch (error) {
      if (error.response) {

        setPopupMessage(`File upload failed`);

      } else {
        setPopupMessage("File upload failed");
      }
      console.error("Error uploading file", error);
    }
  };

  const handleClose = () => {
    setFile(null);
    setProgress(0);
  };

  const [fileType, setFileType] = useState("");

  // JSX
  return (
    <div className="upload-col">
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          textAlign: "center",
          background: dragging ? "#f0f0f0" : "white",
          cursor: "pointer",
        }}
        className="upload-box"
        onClick={() => document.getElementById("fileInput").click()}
        title="Select Image"
      >
        <img src={uploadImg} alt="File-Upload" />
       {file ? (
            file.name
          ) : (
            <>
              Drag & drop files here or <span className="drop-text3">browse your computer</span>
            </>
          )}

        <h5>Maximum file size 50 MB</h5>
      </div>
      <div className="select-type">
  
          <select
          className="sel-input"
          value={fileType}
          onChange={(e) => setFileType(e.target.value)}
        >
               <option value="">Select File Type...</option>
                <option value="receipt-proof-of-purchase">Receipt / Proof of Purchase</option>
                <option value="credit-card-statement">Credit Card Statement</option>
                <option value="bank-statement">Bank Statement</option>
                <option value="flybuys-statement">Flybuys Statement</option>
                <option value="email-confirmation-invoice">Email Confirmation / Invoice</option>
                <option value="other-document-evidence">Other Document / Evidence</option>
      
        </select>

        </div>
      <input
        id="fileInput"
        type="file"
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      {file && (
        <div className="file-progress">
            <h5>Uploading: {progress}%</h5>
            <p>
              <progress value={progress} max="100" />
            </p>
          </div>
      )}
      {file && (
        <button onClick={handleClose} className="close-button">
          Cancel
        </button>
      )}

      <button onClick={handleUpload} className="upload-button">
        Upload
      </button>

      {/* Popup Message */}
      {popupMessage && (
        <PopupMessage
          message={popupMessage}
          onClose={() => setPopupMessage("")}
        />
      )}
    </div>
  );
};

export default UploadFileWidget;
